<template>
  <v-card class="mt-6 user-view-card">
    <v-form ref="form" v-model="isFormValid" @submit.prevent>
      <v-card-title class="mb-4">{{ $t("settings.user_view.title") }}</v-card-title>
      <div class="d-flex user-view-content-wrapper">
        <va-text-input
          required
          :rules="[rules.required, rules.email]"
          v-model="email"
          :label="$t('settings.user_view.email')"
          :placeholder="$t('settings.user_view.email_placeholder')"
          :errorMessages="errorMessages"
          validate-on-blur></va-text-input>
        <v-btn
          type="submit"
          class="submit-button"
          @click="initiateUserView"
          color="primary"
          outlined
          :loading="loading"
          >{{ $t("settings.user_view.submit") }}</v-btn
        >
      </div>
    </v-form>
  </v-card>
</template>

<script>
  import { validateEmail, checkIfUserExists } from "@/assets/utilities/helpers/email";
  import store from "@/store";
  import { eventBus } from "@/event-bus";

  export default {
    name: "UserView",
    data() {
      return {
        email: "",
        isFormValid: false,
        rules: {
          required: value => !!value || this.$t("generic.validation.required"),
          email: value => !!validateEmail(value) || this.$t("generic.validation.email"),
        },
        errorMessages: [],
        loading: false,
      };
    },
    methods: {
      async initiateUserView() {
        this.errorMessages = [];
        this.loading = true;
        if (!this.$refs.form.validate()) return;
        if (this.email === this.$store.state.user.email) {
          this.errorMessages.push(this.$t("settings.user_view.same_user"));
          this.loading = false;

          return;
        }
        const userExists = await checkIfUserExists(this.email);
        if (!userExists.data.message.exists) {
          this.errorMessages.push(this.$t("settings.user_view.email_invalid"));
          this.loading = false;

          return;
        }
        store.commit("SET_USER_IMPERSONATE", this.email);
        store.commit("SET_ORIGINAL_USER", {
          email: this.$store.state.user.email,
          id: this.$store.state.user.id,
        });
        await store.dispatch("refreshAndStoreAllUserData");
        eventBus.$emit("init-impersonate");
        this.$router.push({ name: "dashboard" });

        this.loading = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .user-view-card {
    .user-view-content-wrapper {
      gap: 8px;
      .submit-button {
        height: 46px !important;
        margin-top: 19px;
      }
    }
  }
</style>
```
